import React from 'react'

const PageSheet = ({ children }) => {
  return (
    <div className='page-sheet'>{children}</div>
  )
}

export default PageSheet